import React from "react";
import { AccreditationBigSection } from "@/.storyblok/types/319751/storyblok-components";
import Image from "next/image";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface AccreditorProps {
  blok?: AccreditationBigSection & SbBlokData;
}

const Accreditors: React.FC<AccreditorProps> = ({ blok }) => {
  const headline = blok?.headline || "Our experts are the ones to trust when it comes to your cyber security";
  const accreditations = blok?.accreditations || [];

  return (
    <div {...(blok && storyblokEditable(blok))} className="accent-section">
      <div className="container">
        <div className="accreditors-strip full-width padding-medium text-center">
          <h3 className="accreditors-strip-title white-text">{headline}</h3>

          {/* First Group of Accreditations */}
          <ul className="accreditors-strip-logos">
            {accreditations.slice(0, 5).map((item) => (
              <li key={item._uid} className="accreditors-strip-logo margin-bottom-none">
                {/* Mobile Image */}
                <Image
                  src={item.image?.filename || ""}
                  width={Number(item.width) || 120}
                  height={Number(item.height) || 120}
                  alt={item.alt_image || "Accreditation"}
                  title={item.alt_image || "Accreditation"}
                  className="w-auto mobile-only"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
                {/* Desktop Image */}
                <Image
                  src={item.image?.filename || ""}
                  width={Number(item.width) || 120}
                  height={Number(item.height) || 120}
                  alt={item.alt_image || "Accreditation"}
                  title={item.alt_image || "Accreditation"}
                  className="w-auto hidden-mobile"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              </li>
            ))}
          </ul>

          {/* Second Group of Accreditations */}
          <ul className="accreditors-strip-logos">
            {accreditations.slice(5).map((item) => (
              <li key={item._uid} className="accreditors-strip-logo margin-bottom-none">
                {/* Mobile Image */}
                <Image
                  src={item.image?.filename || ""}
                  width={Number(item.width) || 120}
                  height={Number(item.height) || 120}
                  alt={item.alt_image || "Accreditation"}
                  title={item.alt_image || "Accreditation"}
                  className="w-auto mobile-only"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
                {/* Desktop Image */}
                <Image
                  src={item.image?.filename || ""}
                  width={Number(item.width) || 120}
                  height={Number(item.height) || 120}
                  alt={item.alt_image || "Accreditation"}
                  title={item.alt_image || "Accreditation"}
                  className="w-auto hidden-mobile"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Accreditors;